// extracted by mini-css-extract-plugin
module.exports = {"main":"gallery-module--main--saMqI","title":"gallery-module--title--CpKgS"};